import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import { useMarketParameter } from "../Utils/MarketParameterContext";
import ParameterService from "../Utils/ParameterService";

const Header = (): React.ReactElement => {
  const { parameters } = useMarketParameter();
  const [page, setPage] = useState<string>();

  const parameterService: ParameterService = new ParameterService();

  useEffect(() => {
    if (parameters.APP_HEADER !== undefined && parameters.APP_HEADER !== "") {
      parameterService
        .getPublicHtmlPage(parameters.APP_HEADER)
        .then((response: string) => {
          setPage(response);
        });
    }

    // eslint-disable-next-line
  }, []);

  return <div>{page !== undefined && <div>{parse(page)}</div>}</div>;
};

export default Header;
